import _ from 'lodash';
import { ammendGoogleResult, appendProjectData, appendProjectDataNames, updateViewItemViews } from '../firestoreData/helpers/sheetsDataAdjust';

const _showCallData = false

const sheetsGenericTypes = {
  sheetsGeneric: 'sheetsGeneric',
}

const sheetsFunctionTypes = {
  addSheetRange: 'addSheetRange',
  addSheetRanges: 'addSheetRanges',
  addSheets: 'addSheets',
  addSheetsValidation: 'addSheetsValidation',
  addSheetValidation: 'addSheetValidation',
  addTab: 'addTab',
  createProjectFromSheets: 'createProjectFromSheets',
  createSpreadsheet: 'createSpreadsheet',
  getDocs: 'getDocs',
  getFullSheetRange: 'getFullSheetRange',
  getGoogleSheetsDoc: 'getGoogleSheetsDoc',
  getGoogleSheetsSettingsDoc: 'getGoogleSheetsSettingsDoc',
  getSheetRange: 'getSheetRange',
  getSheetRanges: 'getSheetRanges',
  getSheetsRange: 'getSheetsRange',
  getSheetsRangePure: 'getSheetsRangePure',
  updateSheetRangeValues: 'updateSheetRangeValues',
  updateSheetValues: 'updateSheetValues',
  updateSheetValue: 'updateSheetValue',
  updateSheetRow: 'updateSheetRow',
  updateSheetRowById: 'updateSheetRowById',
  createTeamSheets: 'createTeamSheets',
  updateTournamentScore: 'updateTournamentScore',
}


const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(sheetsGenericTypes.sheetsGeneric, callData)
  return data
}

export const fsfn_sheets = (fsCall, database_fns) => ({
  addGoogleSheetRanges: (googleSheetsId, createValidation) => fsfn_addGoogleSheetRanges(fsCall, googleSheetsId, createValidation),
  addGoogleSheets: (googleSheetsId, paps_state, viKeys) => fsfn_addGoogleSheets(fsCall, googleSheetsId, paps_state, viKeys),
  addGoogleSheetValidation: (googleSheetsId, paps_state, viewItem) => fsfn_addGoogleSheetValidation(fsCall, googleSheetsId, paps_state, viewItem),
  createGoogleSpreadsheet: (title) => fsfn_createGoogleSpreadsheet(fsCall, title),
  createGoogleSpreadsheetTab: (googleSheetsId, name, fetchFirestoreData, values) => fsfn_createGoogleSpreadsheetTab(fsCall, googleSheetsId, name, fetchFirestoreData, values),
  createProjectFromSheets: (sheetProps, sheetOpts) => fsfn_createProjectFromSheets(fsCall, sheetProps, sheetOpts, database_fns),
  createTeamSheets: (googleSheetsId, teams, showLogs) => fsfn_createTeamSheets(fsCall, googleSheetsId, teams, showLogs),
  getGoogleSheetRange: (formData, handleSheetResults, handleSheetError, ignoreStartCase, team, latestSeason, forPlayoffs, forMedia, usePure) => fsfn_getGoogleSheetRange(fsCall, formData, handleSheetResults, handleSheetError, ignoreStartCase, team, latestSeason, forPlayoffs, forMedia, usePure),
  getGoogleSheetSimple: (googleSheetsId, sheetName, handleSheetResults, handleSheetError) => fsfn_getGoogleSheetSimple(fsCall, googleSheetsId, sheetName, handleSheetResults, handleSheetError),
  getGoogleSheetsRange: (sheetProps, appArea) => fsfn_getGoogleSheetsRange(fsCall, sheetProps, appArea),
  getGoogleSheetsRanges: (sheetProps, callback) => fsfn_getGoogleSheetsRanges(fsCall, sheetProps, callback),
  getSheetsFullRange: (googleSheetsId, sheetName) => fsfn_getSheetsFullRange(fsCall, googleSheetsId, sheetName),
  googleDoc: (documentId) => fsfn_googleDoc(fsCall, documentId),
  updateGoogleSheetRow: (match_edit, handleSheetResults, handleSheetError, team) => fsfn_updateGoogleSheetRow(fsCall, match_edit, handleSheetResults, handleSheetError, team),
  updateGoogleSheetRowById: (googleSheetsId, viewItemKey, itemData, useGsid, handleSheetResults, handleSheetError) => fsfn_updateGoogleSheetRowById(fsCall, googleSheetsId, viewItemKey, itemData, useGsid, handleSheetResults, handleSheetError),
  updateGoogleSheetValue: (googleSheetsId, range, value) => fsfn_updateGoogleSheetValue(fsCall, googleSheetsId, range, value),
  updateGoogleSheetValues: (googleSheetsId, name, values) => fsfn_updateGoogleSheetValues(fsCall, googleSheetsId, name, values),
  updateSheetRangeValues: (googleSheetsId, sheetName, cellValue, rowData) => fsfn_updateSheetRangeValues(fsCall, googleSheetsId, sheetName, cellValue, rowData),
  updateTournamentScore: (googleSheetsId, sheetName, homeTeam, awayTeam, homeScore, awayScore, setNumber) => fsfn_updateTournamentScore(fsCall, googleSheetsId, sheetName, homeTeam, awayTeam, homeScore, awayScore, setNumber),
})

/**
 * 
 * @param {string} title  
 * @returns response_data {success, result, error}
 */
export const fsfn_createTeamSheets = async (fsCall, googleSheetsId, teams, showLogs, callback) => {
  try {
    const callData = { sheetFunctionType: sheetsFunctionTypes.createTeamSheets, googleSheetsId, teams, showLogs }
    const response_data = await callFsFunction(fsCall, callData)// OK 
    if (callback) {
      callback(response_data)
    } else {
      return response_data
    }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {string} title  
 * @returns response_data {success, result, error}
 */
export const fsfn_getSheetsFullRange = async (fsCall, googleSheetsId, sheetName, callback) => {
  try {
    const callData = { sheetFunctionType: sheetsFunctionTypes.getFullSheetRange, googleSheetsId, sheetName, showLogs: true }
    const response_data = await callFsFunction(fsCall, callData)// OK 
    if (callback) {
      callback(response_data)
    } else {
      return response_data
    }
  } catch (error) {
    console.error(error)
  }
}

/**
 * Gets the data from a googleSheet using the firebase function `getSheets`
 * @param {object} sheetProps 
 * @param {string} appArea 
 * @param {object} googleSheetsImportOptions 
 * @param {object} _logging 
 * @returns data
 */
const fsfn_createProjectFromSheets = async (fsCall, sheetProps, sheetOpts, database_fns) => {

  try {
    const { formData, pathViews } = sheetProps
    const { appArea, googleSheetsImportOptions, logging, appDataDocuments, staticViews_app, forDataManagement, aps_viewItems, forDemo, forceEmailAuth, authEmail } = sheetOpts
    const { eventName, googleSheetsId } = formData
    const { allowMultiColumnArrays, allowMultiColumnArraysAsObjects } = googleSheetsImportOptions ?? {}

    // LOG me-dev-share@me-mobile-4410b.iam.gserviceaccount.com
    // me-dev-share@me-mobile-4410b.iam.gserviceaccount.com

    // me-mobile-service-account@me-mobile-4410b.iam.gserviceaccount.com
    // me-mobile-service-account@me-dev-share.iam.gserviceaccount.com
    // me-mobile-service-account@me-dev-share.iam.gserviceaccount.com
    // 1_8PjaQBl2JCtMPwUtE_BIKIiJkr_M-ofM4xbCwy90xw
    // 1_8PjaQBl2JCtMPwUtE_BIKIiJkr_M-ofM4xbCwy90xw
    // npx create-next-app@latest modernapp -e with-tailwindcss

    const callData = {
      sheetFunctionType: sheetsFunctionTypes.createProjectFromSheets,
      eventName, googleSheetsId,
      createViews: true, // this will create the fullProject with the views
      appArea,
      fromRegUrl: true,
      keepRowIds: true,
      opts: {
        allowMultiColumnArrays,
        allowMultiColumnArraysAsObjects,
      },
      includeGridData: true,
      useOldPermissions: false,
      showLogs: true,
      authEmail,
      forceEmailAuth,
    }

    const response_data = await callFsFunction(fsCall, callData) // O  
    // each item contains a _gsid, which is the key of the data item

    console.log('response_data', response_data)
    const { success, result } = response_data
    const { result: trueResult } = result ?? {}
    const { projectSettings } = trueResult ?? {}

    getViewItemsSubs(projectSettings)

    if (success && trueResult) {
      if (!trueResult?.projectData?.clientData) { trueResult.projectData.clientData = { clientMobileKey: pathViews.clients } }
      // if (trueResult.projectData?.eventData) { trueResult.projectData.eventData = { name: eventName } }

      // console.log('first', trueResult.projectData.eventData)

      const _trueResult = await ammendGoogleResult(database_fns, trueResult, googleSheetsImportOptions, appDataDocuments, staticViews_app, true, forDataManagement, aps_viewItems, forDemo)

      appendProjectDataNames(_trueResult)

      const ret = {
        success,
        result: _trueResult,
      }
      return ret
    } else {
      return {
        success: false,
        result: {}
      }
    }
  } catch (error) {
    return {
      success: false
    }
  }
}

/**
 * 
 * @param {string} documentId 
 * @returns response_data {success, result, error}
 * @deprecated
 */
const fsfn_googleDoc = async (fsCall, documentId) => {
  try {
    const callData = { sheetsFunctionType: sheetsFunctionTypes.getDocs, documentId }
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {string} title  
 * @returns response_data {success, result, error}
 */
const fsfn_createGoogleSpreadsheet = async (fsCall, title) => {
  try {
    const callData = { sheetFunctionType: sheetsFunctionTypes.createSpreadsheet, title, showLogs: true, useAuthClient: true }
    const response_data = await callFsFunction(fsCall, callData)// OK 
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * adds a sheet (if it doesn't already exist) to an existing spreedsheet and adds the data from the firebase storage
 * @param {*} googleSheetsId 
 * @param {*} paps_state 
 * @param {*} viewItem 
 * @returns response_data {success, result, error} 
 */
const fsfn_createGoogleSpreadsheetTab = async (fsCall, googleSheetsId, name, fetchFirestoreData, values) => {
  try {
    const callData = { sheetFunctionType: sheetsFunctionTypes.addTab, googleSheetsId, name, fetchFirestoreData, values }
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/** Updates a single row in a single range/sheet */
const fsfn_updateSheetRangeValues = async (fsCall, googleSheetsId, sheetName, cellValue, rowData) => {
  try {
    const callData = { sheetFunctionType: sheetsFunctionTypes.updateSheetRangeValues, googleSheetsId, sheetName, cellValue, rowData, showLogs: true }
    const response_data = await callFsFunction(fsCall, callData)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {string} googleSheetsId 
 * @param {object} viewItem 
 * @returns 
 */
const fsfn_updateGoogleSheetValue = async (fsCall, googleSheetsId, range, value) => {

  const callData = { sheetFunctionType: sheetsFunctionTypes.updateSheetValue, googleSheetsId, range, value }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK  
    return response_data
  } catch (error) {
    console.error(error)
  }
}


/**
 * 
 * @param {string} googleSheetsId 
 * @param {object} viewItem 
 * @returns 
 */
const fsfn_updateGoogleSheetValues = async (fsCall, googleSheetsId, name, values) => {

  const callData = { sheetFunctionType: sheetsFunctionTypes.updateSheetValues, googleSheetsId, name, values }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK  
    return response_data
  } catch (error) {
    console.error(error)
  }
}


const fsfn_updateTournamentScore = async (fsCall, googleSheetsId, sheetName, homeTeam, awayTeam, homeScore, awayScore, setNumber) => {
  try {
    const callData = { sheetFunctionType: sheetsFunctionTypes.updateTournamentScore, googleSheetsId, sheetName, homeTeam, awayTeam, homeScore, awayScore, setNumber }
    const response_data = await callFsFunction(fsCall, callData) // OK 
    return response_data
  } catch (error) {
    console.error(error)
  }
}


/**
 * Creates a named range on the 2nd column (name) for sheet (viewItem.key) within the spreadsheet
 * @param {string} googleSheetsId 
 * @param {object} paps_state 
 * @param {object} viewItem 
 * @returns response_data {success, result, error}
 */
const fsfn_addGoogleSheetRange = async (fsCall, googleSheetsId, paps_state, viewItem) => {
  try {
    const callData = { sheetFunctionType: sheetsFunctionTypes.addSheetRange, googleSheetsId, pathViews: paps_state.pathViews, viewItem }
    const response_data = await callFsFunction(callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * Creates a named range on the 2nd column (name) for each of the sheets within the spreadsheet
 * @param {string} googleSheetsId 
 * @param {boolean} createValidation 
 * @returns response_data {success, result, error}
 */
const fsfn_addGoogleSheetRanges = async (fsCall, googleSheetsId, createValidation) => {
  try {
    const callData = { sheetFunctionType: sheetsFunctionTypes.addSheetRanges, googleSheetsId, createValidation }
    const response_data = await callFsFunction(callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * fsfn_addGoogleSheetValidation
 * @param {*} googleSheetsId 
 * @param {*} paps_state 
 * @param {*} viewItem 
 * @returns response_data {success, result, error}
 */
const fsfn_addGoogleSheetValidation = async (fsCall, googleSheetsId, paps_state, viewItem) => {
  try {
    const callData = { sheetFunctionType: sheetsFunctionTypes.addSheetsValidation, googleSheetsId, pathViews: paps_state.pathViews, viewItem }
    const response_data = await callFsFunction(fsCall, callData) // OK
    const { data } = response_data
    const { success, result } = data
    if (success) {
      const { ssResult, ssViews } = result
      const { data: data_result } = ssResult
      const { namedRanges } = data_result
      ssViews.forEach(ssView => {
        const { data: sheetData } = ssView
        const { range, values } = sheetData
        const rangeSplit = range.split('!')
        const rangeName = rangeSplit[0]
        const headers = values ? values[0] : null // values are the rows
        if (headers && rangeName) {
          headers.forEach((header, _index) => {
            const headerRangeName = '_' + _.camelCase(header)
            const nr = _.find(namedRanges, { name: headerRangeName })
            if (nr) {
              _showCallData && console.log('nr', nr)
              // const { name, namedRangeId } = nr
            }
          })
        }
      })
    }
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/** 
 * @param {string} googleSheetsId 
 * @param {object} paps_state 
 * @param {array} viKeys 
 * @returns response_data {success, result, error}
 */
const fsfn_addGoogleSheets = async (fsCall, googleSheetsId, paps_state, viKeys) => {
  try {
    const callData = { sheetFunctionType: sheetsFunctionTypes.addSheets, googleSheetsId, pathViews: paps_state.pathViews, viKeys }
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_getGoogleSheetSimple = async (fsCall, googleSheetsId, sheetName, handleSheetResults, handleSheetError) => {
  try {
    const callData = {
      sheetFunctionType: sheetsFunctionTypes.getSheetsRangePure,
      googleSheetsId: googleSheetsId,
      sheetName,
      fromRegUrl: true
    }
    const response_data = await callFsFunction(fsCall, callData) // OK 
    const { success, result } = response_data ?? {}
    const { error, errors } = result ?? {}
    if (handleSheetResults && success === true) { handleSheetResults(result) }
    if (handleSheetError && success === false) { handleSheetError(error) }
    if (handleSheetError && errors && success === false) { handleSheetError(errors[0]) }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {object} formData (sheetName, googleSheetsId)
 * @param {*} handleSheetResults 
 * @param {*} handleSheetError 
 */
const fsfn_getGoogleSheetRange = async (fsCall, formData, handleSheetResults, handleSheetError, ignoreStartCase, team, latestSeason, forPlayoffs, forMedia, usePure) => {
  try {
    let sheetName = ignoreStartCase ? formData.sheetName : _.startCase(formData.sheetName)
    if (latestSeason) { sheetName += ' ' + latestSeason }
    if (forMedia) { sheetName = 'Media ' + sheetName }
    const callData = {
      sheetFunctionType: usePure ? sheetsFunctionTypes.getSheetsRangePure : sheetsFunctionTypes.getSheetsRange,
      googleSheetsId: formData.googleSheetsId,
      sheetName,
      fromRegUrl: true
    }
    console.log('callData', callData)
    const response_data = await callFsFunction(fsCall, callData) // OK 
    console.log('response_data', response_data)
    const { success, result } = response_data ?? {}
    const { error, errors } = result ?? {}
    if (handleSheetResults && success === true) { handleSheetResults(formData, result, team, forPlayoffs) }
    if (handleSheetError && success === false) { handleSheetError(error) }
    if (handleSheetError && errors && success === false) { handleSheetError(errors[0]) }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {object} sheetProps 
 * @param {string} appArea 
 * @returns ret 
 */
const fsfn_getGoogleSheetsRanges = async (fsCall, sheetProps, callback) => {
  try {
    const { googleSheetsId } = sheetProps
    const callData = { sheetFunctionType: sheetsFunctionTypes.getSheetRanges, googleSheetsId }
    const response_data = await callFsFunction(fsCall, callData) // OK
    const { success, result } = response_data ?? {}
    if (success) {
      const ret = {
        data: {
          success,
          result
        }
      }
      return callback(ret)
    } else {
      callback({
        data: {
          success
        }
      })
    }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {object} sheetProps 
 * @param {string} appArea 
 * @returns ret
 * @deprecated
 */
const fsfn_getGoogleSheetsRange = async (fsCall, sheetProps, appArea) => {
  try {
    const { formData, pathViews } = sheetProps
    const { eventName, googleSheetsId } = formData
    const callData = { sheetFunctionType: sheetsFunctionTypes.getSheetRange, eventName, googleSheetsId, createViews: true, appArea, fromRegUrl: true }
    const response_data = await callFsFunction(fsCall, callData) // OK
    const { success, result } = response_data ?? {}
    if (success) {
      const trueResult = result.result
      if (!trueResult.projectData.clientData) { trueResult.projectData.clientData = { clientMobileKey: pathViews.clients } }
      if (!trueResult.projectData.eventData) { trueResult.projectData.eventData = { name: eventName } }

      updateViewItemViews(trueResult)
      appendProjectData(trueResult)

      const ret = {
        data: {
          success,
          result: trueResult
        }
      }
      return ret
    } else {
      return {
        data: {
          success
        }
      }
    }
  } catch (error) {
    console.error(error)
  }
}

export const fsfn_getGoogleSheetsRange_simple = async (fsCall, googleSheetsId, sheetName, callback) => {
  try {
    const callData = { sheetFunctionType: sheetsFunctionTypes.getSheetRange, googleSheetsId, view: sheetName }
    const response_data = await callFsFunction(fsCall, callData) // OK
    const { success, result } = response_data ?? {}
    if (success) {
      const trueResult = result.result
      const ret = {
        data: {
          success,
          result: trueResult
        }
      }
      callback(ret)
    } else {
      callback({
        data: {
          success
        }
      })
    }
  } catch (error) {
    console.error(error)
  }
}

const fsfn_updateGoogleSheetRowById = async (fsCall, googleSheetsId, viewItemKey, itemData, useGsid, handleSheetResults, handleSheetError) => {
  try {
    const sheetName = viewItemKey
    const callData = { showLogs: true, sheetFunctionType: sheetsFunctionTypes.updateSheetRowById, googleSheetsId, sheetName, itemData, useGsid, allowUpdate: true }
    const response_data = await callFsFunction(fsCall, callData) // OK
    const { success, result } = response_data ?? {}
    const { error, errors } = result ?? {}
    if (handleSheetResults && success === true) { handleSheetResults(result) }
    if (handleSheetError && success === false) { handleSheetError(error) }
    if (handleSheetError && errors && success === false) { handleSheetError(errors[0]) }
  } catch (error) {
    console.error(error)
  }
}

const fsfn_updateGoogleSheetRow = async (fsCall, match_edit, handleSheetResults, handleSheetError, team) => {
  try {
    const { away, home, startDate, results } = match_edit ?? {}
    const { score } = results ?? {}
    const matchData = {
      away: away.name,
      home: home.name,
      homeScore: score.home,
      awayScore: score.away,
      startDate: startDate

    }
    const sheetName = 'Test Results 2024'
    const callData = { showLogs: true, sheetFunctionType: sheetsFunctionTypes.updateSheetRow, googleSheetsId: '17wW4AqQOkVkHTAQ9ttl__AIQQhHadfVf4OppcAZSkLg', sheetName, matchData, allowUpdate: true }
    const response_data = await callFsFunction(fsCall, callData) // OK
    const { success, result } = response_data ?? {}
    const { error, errors } = result ?? {}
    if (handleSheetResults && success === true) { handleSheetResults(result, team) }
    if (handleSheetError && success === false) { handleSheetError(error) }
    if (handleSheetError && errors && success === false) { handleSheetError(errors[0]) }
  } catch (error) {
    console.error(error)
  }
}

const getViewItemsSubs = async (fsCall, projectSettings) => {

  const { viewItems } = projectSettings ?? {}

  const _viewItems = {}

  if (viewItems) {
    if (Object.keys(viewItems).length > 0) {
      // Loop through each view
      _.forEach(viewItems, (viewItem, viewKey) => {
        _viewItems[viewKey] = { subVis: [] }
        const { props } = viewItem
        _.forEach(props, (_prop, propKey) => {
          if (viewItems[propKey]) {
            _viewItems[viewKey].subVis.push(propKey)
          }
        })
      });
      _.forEach(_viewItems, (viewItem, viewKey) => {
        const { subVis } = viewItem ?? {}
        _.forEach(subVis, (subViKey) => {
          if (_viewItems[subViKey] && !_viewItems[subViKey].subVis.includes(viewKey)) {
            _viewItems[subViKey].subVis.push(viewKey)
          }
        })
      })
    }
  }
}
